/* unplugin-vue-components disabled */import { render } from "./attendance.vue?vue&type=template&id=1c11dcc4&ts=true"
import script from "./attendance.vue?vue&type=script&lang=ts"
export * from "./attendance.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__